import React from 'react'
import { IconsProps } from 'msp-integrations'

const PauseIcon = (props: IconsProps) => {
  return (
    <svg
      {...props}
      version='1.1'
      id='Ebene_1'
      x='0px'
      y='0px'
      viewBox='0 0 17 19'
    >
      <path d='M12.75 1H14v17h-1.25V1ZM3 1h1.25v17H3V1Z' fill='#fff' />
    </svg>
  )
}

export default PauseIcon
